import { Component } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-activity-tracker-page',
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  standalone: true,
  templateUrl: './activity-tracker.page.html',
  styleUrl: './activity-tracker.page.scss',
})
export class ActivityTrackerPage {}
